/*
 * Copyright (C) 2026 to Present Applause App Quality, Inc. All rights reserved.
 */

// The numbered page links around the current page, at most 7.
export function pageWindow(page: number, totalPages: number): number[] {
  const start = Math.max(1, Math.min(page - 3, totalPages - 6));
  return Array.from({ length: Math.min(7, totalPages) }, (_, i) => start + i);
}
